// Library imports
import React, { useEffect } from 'react';
import { MDBCol, MDBIcon, MDBInput } from 'mdb-react-ui-kit';
import moment from 'moment';
import { arrayOf, func, shape, string } from 'prop-types';
// Component imports
import Dropdown from '../DropDown';
// Util imports
import { capitalize } from '../../utils/strings';
import { All_FILTERS } from '../../utils/constants';
// Styled components
import { SearchFilterContainer, SearchFilterRow, SearchWrapper } from './styles';

const GameSearchFilter = ({
    games = [],
    setActiveDate,
    activeDate,
    sort = 'Time',
    setSort,
    value = '',
    setValue,
    filters = [],
    setFilters = () => {},
}) => {
    useEffect(() => {
        if (setFilters) setFilters([]);
        setValue('');
        setSort('Time');
    }, [activeDate]);

    return (
        <SearchFilterContainer fluid>
            <SearchFilterRow className="g-0">
                <MDBCol md={12} lg={2} className="first-col" data-tour="game-date-filter">
                    <Dropdown
                        icon={<MDBIcon icon="calendar" />}
                        caption="Game Date"
                        toggleStyle={{
                            background: 'transparent',
                            color: '#94a3b8',
                            borderRadius: 0,
                            borderTopLeftRadius: 999,
                            borderBottomLeftRadius: 999,
                        }}
                        value={moment(activeDate).isValid() ? moment(activeDate).format('ddd MM/DD/YYYY') : '---'}
                        setValue={selectedKey => {
                            const dateOnly = selectedKey.includes(' ') ? selectedKey.split(' ').slice(1).join(' ') : selectedKey;
                            setActiveDate(dateOnly);
                        }}
                        menuItems={[...new Set(games.map(item => moment(item.dateTime).format('MM/DD/YYYY')))]
                            .sort((a, b) => {
                                if (moment(a).isAfter(b)) return 1;
                                if (moment(a).isBefore(b)) return -1;
                                return 0;
                            })
                            .map(date => moment(date).format('ddd MM/DD/YYYY'))}
                    />
                </MDBCol>
                <MDBCol md={12} lg={6} className="search-col" data-tour="search-teams">
                    <SearchWrapper>
                        <MDBInput
                            type="search"
                            placeholder="Start typing team name..."
                            aria-label="Search"
                            id="card-search"
                            value={value}
                            onChange={e => setValue(e.target.value)}
                        />
                    </SearchWrapper>
                </MDBCol>
                <MDBCol md={12} lg={2} className="last-col" data-tour="filter-games">
                    <Dropdown
                        icon={<MDBIcon icon="filter" />}
                        caption="Filter Games"
                        toggleStyle={{
                            background: 'transparent',
                            color: '#94a3b8',
                            borderRadius: 0,
                            borderLeft: `1px solid rgba(255,255,255,0.1)`,
                            borderRight: 0,
                        }}
                        value={
                            All_FILTERS.find(filter => filter.id === filters[0])
                                ? All_FILTERS.find(filter => filter.id === filters[0]).label
                                : capitalize(filters[0])
                        }
                        setValue={selectedKey =>
                            setFilters([
                                All_FILTERS.find(filter => filter.label === selectedKey)
                                    ? All_FILTERS.find(filter => filter.label === selectedKey).id
                                    : selectedKey,
                            ])
                        }
                        menuItems={['Upcoming', 'Live', ...All_FILTERS].map(filter => {
                            return filter.id ? filter.label : filter;
                        })}
                    />
                </MDBCol>
                <MDBCol md={12} lg={2} className="last-col" data-tour="sort-games">
                    <Dropdown
                        icon={<MDBIcon icon="sort" />}
                        caption="Sort Games"
                        toggleStyle={{
                            background: 'transparent',
                            color: '#94a3b8',
                            borderRadius: 0,
                            borderTopRightRadius: 999,
                            borderBottomRightRadius: 999,
                        }}
                        value={sort}
                        setValue={selectedKey => setSort(selectedKey)}
                        menuItems={['Time', 'PW Rating']}
                    />
                </MDBCol>
            </SearchFilterRow>
        </SearchFilterContainer>
    );
};

GameSearchFilter.propTypes = {
    games: arrayOf(shape({})),
    setActiveDate: func.isRequired,
    activeDate: string.isRequired,
    setSort: func.isRequired,
    sort: string.isRequired,
    value: string,
    setValue: func.isRequired,
    filters: arrayOf(string),
    setFilters: func,
};

export default GameSearchFilter;
